
import Vue, { CreateElement, RenderContext, VNode } from "vue";
import draggable from "vuedraggable";

interface Props {
  isDraggable: boolean | undefined;
  dragDisabled: boolean | undefined;
  tag: string | undefined;
}

export default Vue.extend({
  functional: true,
  name: "Draggable",
  render(h: CreateElement, ctx: RenderContext<Props>): VNode {
    const isDraggable = ctx.props.isDraggable !== undefined ? ctx.props.isDraggable : true;
    const tag = ctx.props.tag !== undefined ? ctx.props.tag : "div";
    const defaultSlot = ctx.scopedSlots.default && ctx.scopedSlots.default({});
    if (!isDraggable) return h(tag, ctx.data, defaultSlot);
    const draggableOptions = {
      ...ctx.data,
      attrs: {
        delay: 200,
        delayOnTouchOnly: true,
        supportPointer: false,
        disabled: !!ctx.props.dragDisabled,
        tag,
        ghostClass: "draggableGhost",
      },
      on: {
        update: ({ oldIndex, newIndex }: any) => {
          const handler = ctx.listeners.update;
          if (handler) {
            if (Array.isArray(handler)) handler.forEach(i => i({ oldIndex, newIndex }));
            else handler({ oldIndex, newIndex });
          }
        },
      },
    };
    return h(draggable, draggableOptions, defaultSlot);
  },
});
